import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c034206"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "account-flextime" }
const _hoisted_2 = { class: "fh-c-b" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"padding-left":"10px"} }, [
  /*#__PURE__*/_createElementVNode("p", null, "弹性工作时间"),
  /*#__PURE__*/_createElementVNode("p", { style: {"color":"#999999","font-size":"12px"} }, "客服的工作时间默认与营业时间一致，如有不同，可单独设置弹性工作时间"),
  /*#__PURE__*/_createElementVNode("p", { style: {"color":"#999999","font-size":"12px"} }, "设置后，该客服处理工单的响应速度和处理工时，将只按照本人的工作时间进行计算（扣除非工作时段）")
], -1))
const _hoisted_4 = {
  key: 0,
  class: "fh-s-b"
}
const _hoisted_5 = { class: "week-day__name" }
const _hoisted_6 = { class: "prefix" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "tips" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "提醒", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"color":"#999999","font-size":"12px"} }, "1. 每天的结束时间不得大于23:59", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"color":"#999999","font-size":"12px"} }, "2. 单个时间段，结束时间必须大于等于开始时间", -1))
const _hoisted_13 = [
  _hoisted_10,
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = { class: "page-footer" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("更新")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_time_picker = _resolveComponent("a-time-picker")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_a_switch, {
          "checked-children": "开",
          "un-checked-children": "关",
          checked: _ctx.workTime.status,
          disabled: !_ctx.hasPermission('engieer_update'),
          onClick: _ctx.handleSwitch
        }, null, 8, ["checked", "disabled", "onClick"])
      ]),
      (_ctx.week.length > 0)
        ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.week, (day, l) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "week-day",
                key: l
              }, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(day.day), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(day.times, (time, m) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "week-day__hours fh",
                    key: l + '-' + m,
                    style: _normalizeStyle({ 'margin-bottom': m % 2 === 1 ? '20px' : '4px' })
                  }, [
                    _createElementVNode("div", _hoisted_6, _toDisplayString(m % 2 === 0 ? '启' : '止'), 1),
                    _createVNode(_component_a_time_picker, {
                      value: _ctx.week[l].times[m],
                      "onUpdate:value": ($event: any) => ((_ctx.week[l].times[m]) = $event),
                      "value-format": "HH:mm",
                      format: "HH:mm",
                      "allow-clear": false,
                      onChange: ($event: any) => (_ctx.handleChange(l, m))
                    }, null, 8, ["value", "onUpdate:value", "onChange"])
                  ], 4))
                }), 128)),
                (day.times.length > 2)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "week-day__btn",
                      onClick: ($event: any) => (_ctx.handleDelete(l))
                    }, "删除", 8, _hoisted_7))
                  : _createCommentVNode("", true),
                (day.times.length < 10)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "week-day__btn",
                      onClick: ($event: any) => (_ctx.handleAdd(l))
                    }, "增加时段", 8, _hoisted_8))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ], 512)), [
            [_vShow, _ctx.workTime.status]
          ])
        : _createCommentVNode("", true),
      _withDirectives(_createElementVNode("div", _hoisted_9, _hoisted_13, 512), [
        [_vShow, _ctx.workTime.status]
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createVNode(_component_a_button, {
        style: {"margin-right":"10px"},
        disabled: !_ctx.hasPermission('engieer_update'),
        type: "primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleSubmit(_ctx.workTime.status)))
      }, {
        default: _withCtx(() => [
          _hoisted_15
        ]),
        _: 1
      }, 8, ["disabled"])
    ])
  ], 64))
}